import _ from 'lodash';
import React, {createContext, FC, ReactNode, useContext, useMemo, useState} from 'react';

import {OnboardingFlowNameEnum, OnboardingFlowStepNameEnum} from './onboardingFlowTypes';

interface OnboardingFlowContextProps {
  onboardingFlow: OnboardingFlowNameEnum | undefined;
  setOnboardingFlow: (flow: OnboardingFlowNameEnum | undefined) => void;
  onboardingFlowStep: OnboardingFlowStepNameEnum | undefined;
  setOnboardingFlowStep: (step: OnboardingFlowStepNameEnum | undefined) => void;
}

const OnboardingFlowContext = createContext<OnboardingFlowContextProps>({
  onboardingFlow: undefined,
  setOnboardingFlow: _.noop,
  onboardingFlowStep: undefined,
  setOnboardingFlowStep: _.noop,
});

export function useOnboardingFlowState() {
  return useContext(OnboardingFlowContext);
}

interface OnboardingFlowProviderProps {
  children: ReactNode;
}

export const OnboardingFlowProvider: FC<OnboardingFlowProviderProps> = (props) => {
  const {children} = props;

  const [onboardingFlow, setOnboardingFlow] = useState<OnboardingFlowNameEnum | undefined>(undefined);
  const [onboardingFlowStep, setOnboardingFlowStep] = useState<OnboardingFlowStepNameEnum | undefined>(
    undefined,
  );

  const context = useMemo(
    () => ({
      onboardingFlow,
      setOnboardingFlow,
      onboardingFlowStep,
      setOnboardingFlowStep,
    }),
    [onboardingFlow, setOnboardingFlow, onboardingFlowStep, setOnboardingFlowStep],
  );

  return <OnboardingFlowContext.Provider value={context}>{children}</OnboardingFlowContext.Provider>;
};
